import 'dayjs/locale/ru';

import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import localeData from 'dayjs/plugin/localeData';

dayjs.locale('ru');
dayjs.extend(customParseFormat);
dayjs.extend(localeData);
